export default "__VITE_ASSET__98aeb213__"